import styled, { css } from "styled-components";

import { colorsPalettes } from "@similarweb/styles";

/**
 * Sits outside the scroll container, pinned to its edges. It used to be `position: sticky` *inside*
 * the scroller, which kept it visible but also made it occupy 6px of scrollable content — putting the
 * virtualiser's row offsets out of phase with the container's real `scrollTop`.
 */
export const StyledAddedItemIndicator = styled.div<{ position: "top" | "bottom" }>`
    position: absolute;
    ${(p) =>
        p.position === "top"
            ? css`
                  top: 0;
              `
            : css`
                  bottom: 0;
              `}
    left: 0;
    right: 0;
    height: 6px;
    background-color: ${colorsPalettes.blue[300]};
    opacity: 0;
    pointer-events: none;
    z-index: 1;
`;
